import React, { useState, useEffect, useRef } from 'react';
import { FileUploaderInline } from "@uploadcare/react-uploader";
import MediaUploader from 'app/components/PostingTool/MediaUploader.js';


const UploadcareModal = (props) => {
    const [ sourceList, setSourceList ] = useState('');
    const [ isVisible, setIsVisible ] = useState(false);
    const [ filesToUpload, setFilesToUpload ] = useState([]);
    const [ completedFiles, setCompletedFiles ] = useState([]);

    let content = null,
        config = props.app.config,
        uploaderRef = useRef(null);

    useEffect(() => {
        setSourceList(props.sourceList);
    }, [props.sourceList]);

    useEffect(() => {
        if (sourceList !== '' && uploaderRef.current && !isVisible) {
            uploaderRef.current.api.setCurrentActivity('external', {
                externalSourceType: sourceList
            });
            uploaderRef.current.api.setModalState(true);
            setIsVisible(true);
        }
    }, [sourceList]);

    useEffect(() => {
        filesToUpload.map((uuid) => {
            if (completedFiles.indexOf(uuid) === -1) {
                let nextCompletedFiles = [...completedFiles];
                nextCompletedFiles.push(uuid);
                setCompletedFiles(nextCompletedFiles);

                let formData = new FormData();

                formData.append('mediaSource', 'uploadcare');
                formData.append('mediaId', uuid);


                MediaUploader({
                    formData,
                    responseCallback: (response) => {
                        let data = response.data;

                        if (props.accessoryServiceId !== undefined) {
                            props.attachMedia(data, props.accessoryServiceId);
                        } else {
                            props.attachMedia(data);
                        }

                        if (data.val_result !== undefined && data.val_result.payload !== undefined) {
                            if (Object.keys(data.val_result.payload).length) {
                                props.updateMediaErrors(data.val_result.payload);
                            }
                        } else {
                            if (props.accessoryServiceId !== undefined) {
                                props.clearMediaErrors([props.accessoryServiceId]);
                            }
                        }
                    },
                    errorCallback: (error) => {
                        if (error.response) {
                            let errorData = error.response.data.errors || null,
                                errorMsgs = [];

                            const extractErrors = (obj) => {
                                if (obj && Object.keys(obj).length) {
                                    Object.keys(obj).map((key) => {
                                        if (typeof obj[key] === 'string') {
                                            errorMsgs.push(obj[key]);
                                        } else if (Object.keys(obj[key])) {
                                            extractErrors(obj[key]);
                                        }
                                    });
                                }
                            };

                            // session died before upload
                            if (error.response.status === 403) {
                                window.location.reload();
                                return;
                            }

                            if (error.response.status === 413) {
                                props.updateMediaErrors(mediaError);
                                props.cancelAction();
                                return;
                            }

                            extractErrors(errorData);

                            if (errorMsgs.length) {
                                if (props.accessoryServiceId !== undefined) {
                                    let mediaError = {};
                                    mediaError[props.accessoryServiceId] = errorMsgs.join(" ");
                                    props.updateMediaErrors(mediaError);
                                    props.cancelAction();
                                }
                            }
                        } else if (error.message) {
                            if (props.accessoryServiceId !== undefined) {
                                let mediaError = {};
                                mediaError[props.accessoryServiceId] = error.message;
                                props.updateMediaErrors(mediaError);
                                props.cancelAction();
                            }
                        }
                    }
                });

            }
        })
    }, [filesToUpload]);

    content = (
        <div className="uploadcare-container">
            <FileUploaderInline
                apiRef={uploaderRef}
                sourceList={sourceList}
                pubkey={config.ucKey}
                useCloudImageEditor={false}
                checkForUrlDuplicates={true}
                accept={"image/*, video/*"}
                onActivityChange={(e) => {
                    // we open to the extenal and when the 'x' is clicked
                    // the start-from event is sent so we can close the modal
                    if (e.activity === 'start-from') {
                        props.cancelAction(e);
                    }

                }}
                onFileUploadSuccess={(e, extra) => {
                    let nextFilesToUpload = [...filesToUpload];

                    if (nextFilesToUpload.indexOf(e.uuid) === -1) {
                        nextFilesToUpload.push(e.uuid);
                        setFilesToUpload(nextFilesToUpload);
                    }

                }}/>
        </div>
    )

    return content;

};

export default UploadcareModal;
